(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function shuffle(list) {
      for (var i = list.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = list[i]; list[i] = list[j]; list[j] = t;
      }
      return list;
    }

    // Order cards so each group of 4 shows a brand at most once when the
    // pool allows; pinned cards keep their place at the front.
    function spreadBrands(list, count) {
      var perPage = 4;
      var out = [];
      var pool = list.slice();
      while (out.length < count && pool.length) {
        var pageStart = Math.floor(out.length / perPage) * perPage;
        var used = out.slice(pageStart).map(function (li) { return li.dataset.brand; });
        var pick = 0;
        if (!pool[0].hasAttribute('data-pinned')) {
          for (var i = 0; i < pool.length; i++) {
            if (used.indexOf(pool[i].dataset.brand) === -1) { pick = i; break; }
          }
        }
        out.push(pool.splice(pick, 1)[0]);
      }
      return out.concat(pool);
    }

    function setup(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var grid = root.querySelector('.lux-products__grid');
      if (!grid) return;

      var items = Array.prototype.slice.call(grid.children);
      if (root.hasAttribute('data-shuffle')) {
        // Picked products keep their place at the front
        var pinned = items.filter(function (li) { return li.hasAttribute('data-pinned'); });
        var rest = items.filter(function (li) { return !li.hasAttribute('data-pinned'); });
        items = pinned.concat(shuffle(rest));
      }
      if (!root.hasAttribute('data-grouped')) {
        items = spreadBrands(items, parseInt(root.dataset.count, 10) || 16);
      }
      var count = parseInt(root.dataset.count, 10) || 16;
      items.forEach(function (li, i) { if (i >= count) li.remove(); });
      items = items.slice(0, count);

      var perPage = 4;
      var pages = Math.ceil(items.length / perPage);
      if (pages < 2) {
        items.forEach(function (li) { grid.appendChild(li); });
        return;
      }

      // viewport > track > page > ul (grid of 4)
      var viewport = document.createElement('div');
      viewport.className = 'lux-carousel__viewport';
      var track = document.createElement('ul');
      track.className = 'lux-carousel__track';
      track.setAttribute('role', 'list');
      for (var p = 0; p < pages; p++) {
        var page = document.createElement('li');
        page.className = 'lux-carousel__page';
        page.setAttribute('aria-roledescription', 'slide');
        page.setAttribute('aria-label', (p + 1) + ' of ' + pages);
        var ul = document.createElement('ul');
        ul.setAttribute('role', 'list');
        items.slice(p * perPage, p * perPage + perPage).forEach(function (li) {
          li.classList.remove('lux-reveal');
          ul.appendChild(li);
        });
        page.appendChild(ul);
        track.appendChild(page);
      }
      // A copy of the first page at the end keeps the loop sliding left
      var clone = track.firstElementChild.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
      track.appendChild(clone);
      viewport.appendChild(track);
      grid.replaceWith(viewport);

      var interval = (parseFloat(root.dataset.interval) || 5) * 1000;
      root.style.setProperty('--lux-interval', interval / 1000 + 's');
      var current = 0;
      var timer = null;
      var paused = false;
      var stopped = false;
      var toggle = null;

      var dots = root.querySelector('.lux-carousel__dots');
      if (dots) {
        for (var d = 0; d < pages; d++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'lux-carousel__dot';
          b.setAttribute('aria-label', 'Show products ' + (d * perPage + 1) + ' to ' + Math.min((d + 1) * perPage, items.length));
          b.dataset.index = d;
          b.addEventListener('click', function () { go(parseInt(this.dataset.index, 10), true); });
          dots.appendChild(b);
        }
        // Pause / play: autoplay must be stoppable (WCAG 2.2.2)
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'lux-carousel__toggle';
        toggle.addEventListener('click', function () {
          stopped = !stopped;
          restart();
        });
        dots.appendChild(toggle);
        dots.hidden = false;
      }

      function markToggle() {
        if (!toggle) return;
        toggle.setAttribute('aria-label', stopped ? 'Play' : 'Pause');
        toggle.innerHTML = stopped
          ? '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M5 3.5v9l7-4.5z" fill="currentColor"/></svg>'
          : '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M5 3.5v9M11 3.5v9" stroke="currentColor" stroke-width="1.4"/></svg>';
      }

      function markDots() {
        if (!dots) return;
        var active = current % pages;
        dots.querySelectorAll('.lux-carousel__dot').forEach(function (b, i) {
          b.removeAttribute('aria-current');
          if (i === active) {
            void b.offsetWidth; // restart the progress fill
            b.setAttribute('aria-current', 'true');
          }
        });
      }

      function snapToStart() {
        // On the copy of page 1: jump back to the real page 1 unseen
        track.classList.add('is-resetting');
        current = 0;
        track.style.transform = 'translate3d(0, 0, 0)';
        void track.offsetWidth;
        track.classList.remove('is-resetting');
      }

      function go(index, user) {
        // transitionend can be skipped (background tab, interrupted slide),
        // so never move past the copy of page 1
        if (current >= pages) snapToStart();
        if (index > pages) index = 1;
        current = index;
        track.style.transform = 'translate3d(' + (-100 * current) + '%, 0, 0)';
        var page = track.children[current];
        if (page && !reduce.matches) {
          page.classList.remove('is-entering');
          void page.offsetWidth;
          page.classList.add('is-entering');
        }
        markDots();
        if (user) restart();
      }

      track.addEventListener('transitionend', function (e) {
        if (e.target !== track || current !== pages) return;
        snapToStart();
      });

      function stop() { clearInterval(timer); timer = null; }
      function restart() {
        stop();
        markToggle();
        if (stopped || paused || reduce.matches || document.hidden) {
          root.classList.add('is-paused');
          return;
        }
        root.classList.remove('is-paused');
        markDots();
        timer = setInterval(function () {
          // Only advance while at least a quarter of the row is on screen
          if (!inView()) return;
          go(current + 1, false);
        }, interval);
      }

      function inView() {
        var r = viewport.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        var seen = Math.min(r.bottom, h) - Math.max(r.top, 0);
        return seen > r.height * 0.25;
      }

      // Keyboard users tabbing through cards get a still row; the mouse
      // resting over a row no longer freezes it
      root.addEventListener('focusin', function (e) {
        if (e.target === toggle) return;
        paused = true; restart();
      });
      root.addEventListener('focusout', function () { paused = false; restart(); });
      document.addEventListener('visibilitychange', restart);
      if (reduce.addEventListener) reduce.addEventListener('change', restart);

      // Swipe on touch screens
      var startX = null;
      viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        var real = current % pages;
        go(dx < 0 ? real + 1 : (real - 1 + pages) % pages, true);
      }, { passive: true });

      go(0, false);
      restart();
    }

    function init() {
      document.querySelectorAll('[data-lux-carousel]').forEach(setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
